import { render, staticRenderFns } from "./NocDetail.vue?vue&type=template&id=6857e3aa&scoped=true"
import script from "./NocDetail.vue?vue&type=script&lang=js"
export * from "./NocDetail.vue?vue&type=script&lang=js"
import style0 from "./NocDetail.vue?vue&type=style&index=0&id=6857e3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6857e3aa",
  null
  
)

export default component.exports